<template>
    <div id="app" class="bg-light">
        <LayoutHeader
          @preview-product="previewProduct($event)">
        </LayoutHeader>
        <ProductPreview :show="showPreview" :item="previewItem" @close-preview="showPreview = false"/>
        <main>
          <transition name="fade-in-up">
            <router-view @preview-product="previewProduct($event)" style="mmin-height: 1024px" />
          </transition>
        </main>
      <LayoutFooter></LayoutFooter>
    </div>
</template>

<style lang="scss">
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }
</style>

<script>
    import LayoutHeader from "@/components/layout/LayoutHeader.vue";
    import LayoutFooter from "@/components/layout/LayoutFooter.vue";
    import ProductPreview from "@/components/products/ProductPreview";
    
    export default {
        name: "Home",
        
        data() {
            return {
              showPreview: false,
              previewItem: null
            }
        },
      
        components: {
            LayoutHeader,
            LayoutFooter,
            ProductPreview
        },
      
        methods: {
          previewProduct(item) {
            console.log("preview item #" + item.uid)
            this.previewItem = item;
            this.showPreview = true;
          }
        }
    };
</script>
